export default __webpack_public_path__ + "fonts/text-web.d4d2a6371736a75b04ecbee5d71cf366.png";